import setup from "./setup";

const app = setup();
app.mount("#app");
